module.exports = __webpack_public_path__ + "img/right-arrow.e0875d05.svg";